const WELCOME_EVENT_NAME = "smokeraven:welcome-overlay";

export const triggerWelcomeOverlay = () => {
  window.dispatchEvent(new CustomEvent(WELCOME_EVENT_NAME));
};

export { WELCOME_EVENT_NAME };
